function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m384 488h-352a8 8 0 0 1 -8-8v-388.68628a8 8 0 0 1 2.34314-5.65685l59.31368-59.31372a8 8 0 0 1 5.65686-2.34315h292.68632a8 8 0 0 1 8 8v448a8 8 0 0 1 -8 8z",
  fill: "#2b93cb"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m80 88a8.00008 8.00008 0 0 0 8-8v-55.22266a7.95929 7.95929 0 0 0 -2.34326 1.56592l-59.31348 59.31348a7.96882 7.96882 0 0 0 -1.56592 2.34326z",
  fill: "#5ab9e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m160 144h32v104h-32z",
  fill: "#195185",
  transform: "matrix(-1 0 0 -1 352 392)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m128 168h32v80h-32z",
  fill: "#216ead",
  transform: "matrix(-1 0 0 -1 288 416)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m96 192h32v56h-32z",
  fill: "#5ab9e6",
  transform: "matrix(-1 0 0 -1 224 440)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m64 216h32v32h-32z",
  fill: "#c2effc",
  transform: "matrix(-1 0 0 -1 160 464)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m232 240h224v32h-224z",
  fill: "#5ab9e6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m232 456h224v32h-224z",
  fill: "#5ab9e6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m328 176h-64v16l8 8v40h48v-40l8-8z",
  fill: "#eeba2b"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m272 144h48v32h-48z",
  fill: "#ffeeba"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m272 272h48a0 0 0 0 1 0 0v160a24 24 0 0 1 -24 24 24 24 0 0 1 -24-24v-160a0 0 0 0 1 0 0z",
  fill: "#eeba2b"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m424 176h-64v16l8 8v40h48v-40l8-8z",
  fill: "#eeba2b"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m368 144h48v32h-48z",
  fill: "#ffeeba"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m368 272h48a0 0 0 0 1 0 0v160a24 24 0 0 1 -24 24 24 24 0 0 1 -24-24v-160a0 0 0 0 1 0 0z",
  fill: "#eeba2b"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m456 184h32v304h-32z",
  fill: "#2b93cb"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m32 96h48a16.01582 16.01582 0 0 0 16-16v-48h288v72h16v-72a16.01582 16.01582 0 0 0 -16-16h-292.6875a15.89068 15.89068 0 0 0 -11.3125 4.6875l-59.3125 59.3125a15.89068 15.89068 0 0 0 -4.6875 11.3125v388.6875a16.01582 16.01582 0 0 0 16 16h168v-16h-168zm11.3125-16 36.6875-36.6875v36.6875z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m160 56h64v16h-64z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m240 56h32v16h-32z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m136 88h64v16h-64z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m216 88h24v16h-24z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m256 88h40v16h-40z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m488 176h-32a8.00039 8.00039 0 0 0 -8 8v48h-24v-28.6875l5.65625-5.65625a8.001 8.001 0 0 0 2.34375-5.65625v-16a8.00039 8.00039 0 0 0 -8-8v-24a8.00039 8.00039 0 0 0 -8-8h-48a8.00039 8.00039 0 0 0 -8 8v24a8.00039 8.00039 0 0 0 -8 8v16a8.001 8.001 0 0 0 2.34375 5.65625l5.65625 5.65625v28.6875h-32v-28.6875l5.65625-5.65625a8.001 8.001 0 0 0 2.34375-5.65625v-16a8.00039 8.00039 0 0 0 -8-8v-24a8.00039 8.00039 0 0 0 -8-8h-48a8.00039 8.00039 0 0 0 -8 8v24a8.00039 8.00039 0 0 0 -8 8v16a8.001 8.001 0 0 0 2.34375 5.65625l5.65625 5.65625v28.6875h-32a8.00039 8.00039 0 0 0 -8 8v32a8.00039 8.00039 0 0 0 8 8h32v152a31.63057 31.63057 0 0 0 4.45166 16h-36.45166a8.00039 8.00039 0 0 0 -8 8v32a8.00039 8.00039 0 0 0 8 8h256a8.00039 8.00039 0 0 0 8-8v-304a8.00039 8.00039 0 0 0 -8-8zm-160 104h32v152a31.63057 31.63057 0 0 0 4.45166 16h-40.90332a31.63057 31.63057 0 0 0 4.45166-16zm48 152v-152h32v152a16 16 0 0 1 -32 0zm48 0v-152h24v168h-28.45166a31.63057 31.63057 0 0 0 4.45166-16zm-48-280h32v16h-32zm-2.34375 42.34375-5.65625-5.65625v-4.6875h48v4.6875l-5.65625 5.65625a8.001 8.001 0 0 0 -2.34375 5.65625v32h-32v-32a8.001 8.001 0 0 0 -2.34375-5.65625zm-93.65625-42.34375h32v16h-32zm-2.34375 42.34375-5.65625-5.65625v-4.6875h48v4.6875l-5.65625 5.65625a8.001 8.001 0 0 0 -2.34375 5.65625v32h-32v-32a8.001 8.001 0 0 0 -2.34375-5.65625zm-37.65625 53.65625h208v16h-208zm40 184v-152h32v152a16 16 0 0 1 -32 0zm-40 32h208v16h-208zm240 16h-16v-288h16z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m192 136h-32a8.00039 8.00039 0 0 0 -8 8v16h-24a8.00039 8.00039 0 0 0 -8 8v16h-24a8.00039 8.00039 0 0 0 -8 8v16h-24a8.00039 8.00039 0 0 0 -8 8v32a8.00039 8.00039 0 0 0 8 8h128a8.00039 8.00039 0 0 0 8-8v-104a8.00039 8.00039 0 0 0 -8-8zm-120 88h16v16h-16zm32-24h16v40h-16zm32-24h16v64h-16zm48 64h-16v-88h16z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m168 272h16v16h-16z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m136 272h16v16h-16z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m104 272h16v16h-16z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m72 272h16v16h-16z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m112 320h24v16h-24z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m152 320h40v16h-40z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m64 352h56v16h-56z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m136 352h24v16h-24z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m176 352h16v16h-16z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m64 384h40v16h-40z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m120 384h16v16h-16z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m152 384h40v16h-40z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m64 416h24v16h-24z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m104 416h40v16h-40z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m160 416h32v16h-32z"
});

var SvgResults = function SvgResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filled_outline",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    "data-name": "filled outline",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/results.af599e5f.svg";
export { ForwardRef as ReactComponent };